<template>
    <PanelV2
      type="w7"
      title="Grow your business with cashless payment acceptance!"
      @nextClick="commitData"
    >
      <template v-slot:content-solt>
        <Digital :digitalData="formData" @checkboxClick="updateCheckedData" />
      </template>
    </PanelV2>
</template>

<script>
  import Digital from "./common/Digital.vue";
  import API from "@/api";

  export default {
    name: 'SolePropB',
    pRouter: 'SolePropA',
    components: {
      Digital,
    },
    data() {
      return {
        formData: null,
       isSelected: true,
      }
    },
    methods: {
      updateCheckedData(data) {
        this.formData = data;
      },
      commitData() {
        if(this.formData.every(val => val.chooseFlag == '2')) {
          this.isSelected = false
        }
        const data = this.formatCommitData({digitalPaymentList: this.formData})

        API.addBdoProcess({
          ...data
        }).then(res => {
          if (res.success) {
            this.toNext({query: {isSelected: this.isSelected}})
          }
        })
      }
    }
  }
</script>


<style lang="scss" scoped>

</style>
